import { ProductModel } from 'interfaces'
import { useSearchStore } from '../../../../src/store/search/SearchStore'
import { useSellerStore } from '../../../../src/store/search/SellerStore'
import { ICartProductData, useCartProduct } from 'cart'

interface IProductInfoProps {
  product: ProductModel
}

export interface IProductInfo {
  cartProduct: ICartProductData
}

export const useProductInfo = (props: IProductInfoProps): IProductInfo => {
  const { product } = props

  const searchStore = useSearchStore()
  const { getSelectedSeller } = useSellerStore()

  const cartProduct = useCartProduct({
    product,
    vehicle: searchStore.currentVehicle,
    sellerDetails: getSelectedSeller(),
  })

  return { cartProduct }
}
